const config = {
  // donationUrl: 'https://training.christmasdaddies.org/donations/web',
  donationUrl: 'https://donation.christmasdaddies.org/donations/web',
};

export default config;